export default "__VITE_ASSET__536d49c3__"